import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import { AiFillStar } from 'react-icons/ai';
import { BsWhatsapp } from 'react-icons/bs';
import {
    FaGraduationCap,
    FaCalculator,
    FaWallet,
    FaMedal,
    FaChartBar,
    FaLayerGroup,
} from 'react-icons/fa';

import logo from '../../assets/img/logo.png';
import heroDashboardScreen from '../../assets/img/hero-dashboard-screen.png';
import { handleWhatsAppClick } from '../../utils/suport';

import {
    LandingRoot,
    AmbientLayer,
    ContentZ,
    SiteHeader,
    HeaderInner,
    HeaderLogoLink,
    NavLinks,
    HeaderActions,
    BtnPrimary,
    BtnGhost,
    BtnOutlineAffirm,
    HeroSection,
    HeroBadge,
    HeroTitle,
    HeroLead,
    HeroCtas,
    StatRow,
    Stat,
    HeroVisual,
    HeroDevice,
    HeroDeviceBezel,
    HeroDeviceScreen,
    HeroDeviceBase,
    Section,
    SectionHeader,
    SectionKicker,
    SectionTitle,
    SectionLead,
    AboutSection,
    AboutInner,
    AboutProse,
    FeatureGrid,
    FeatureCard,
    FeatureIcon,
    FeatureText,
    VideoSection,
    VideoInner,
    VideoFrame,
    TestimonialsGrid,
    QuoteCard,
    QuoteText,
    QuoteAuthor,
    Stars,
    SiteFooter,
    FooterWrap,
    FooterAccentLine,
    FooterTop,
    FooterSupportCol,
    FooterLegalCol,
    FooterTitle,
    FooterMuted,
} from './landingStyles';

export default function Home() {
    const { t } = useTranslation();
    const [year, setYear] = useState(null);
    const [logged, setLogged] = useState(null);

    useEffect(() => {
        const el = document.getElementById('containerLayout');
        if (el) el.style.height = 'auto';
        setYear(new Date().getFullYear());
        setLogged(localStorage.getItem('@user_token'));
    }, []);

    const featureItems = [
        { icon: <FaLayerGroup />, text: t('home_section_features_item_1') },
        { icon: <FaGraduationCap />, text: t('home_section_features_item_2') },
        { icon: <FaCalculator />, text: t('home_section_features_item_3') },
        { icon: <FaWallet />, text: t('home_section_features_item_4') },
        { icon: <FaMedal />, text: t('home_section_features_item_5') },
        { icon: <FaChartBar />, text: t('home_section_features_item_6') },
    ];

    const testimonials = [
        { quote: t('home_feedback_card_1'), author: 'Francisco Nunes' },
        { quote: t('home_feedback_card_2'), author: 'Emerson Santos' },
        { quote: t('home_feedback_card_3'), author: 'Sillas Xavier' },
        { quote: t('home_feedback_card_4'), author: 'Taynara Souza' },
    ];

    return (
        <LandingRoot id="landing-home">
            <AmbientLayer />
            <ContentZ>
                <SiteHeader>
                    <HeaderInner>
                        <HeaderLogoLink to="/" aria-label="GBinary home">
                            <img src={logo} alt="GBinary" />
                        </HeaderLogoLink>
                        <NavLinks>
                            <a href="#video">{t('home_nav_how_to_use')}</a>
                            <a href="#recursos">{t('home_nav_features')}</a>
                            <a href="#sobre">{t('home_nav_about')}</a>
                        </NavLinks>
                        <HeaderActions>
                            {!logged ? (
                                <>
                                    <BtnGhost to="/login">{t('home_landing_cta_secondary')}</BtnGhost>
                                    <BtnPrimary to="/register">{t('home_header_btn_register')}</BtnPrimary>
                                </>
                            ) : (
                                <>
                                    <BtnOutlineAffirm
                                        role="button"
                                        tabIndex={0}
                                        onClick={() => {
                                            localStorage.clear();
                                            window.location = '/';
                                        }}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter' || e.key === ' ') {
                                                localStorage.clear();
                                                window.location = '/';
                                            }
                                        }}
                                    >
                                        {t('home_header_btn_exit')}
                                    </BtnOutlineAffirm>
                                    <BtnPrimary to="/dashboard">{t('home_header_btn_enter')}</BtnPrimary>
                                </>
                            )}
                        </HeaderActions>
                    </HeaderInner>
                </SiteHeader>

                <HeroSection id="hero">
                    <div>
                        <HeroBadge>{t('home_landing_badge')}</HeroBadge>
                        <HeroTitle>
                            <Trans
                                i18nKey="home_landing_title"
                                components={{ accent: <span className="accent" /> }}
                            />
                        </HeroTitle>
                        <HeroLead>{t('home_landing_subtitle')}</HeroLead>
                        <HeroCtas>
                            <BtnPrimary to={logged ? '/dashboard' : '/register'}>
                                {logged ? t('home_btn_open_app') : t('home_btn_start')}
                            </BtnPrimary>
                            {!logged && <BtnGhost to="/login">{t('home_header_btn_enter')}</BtnGhost>}
                        </HeroCtas>
                        <StatRow>
                            <Stat>
                                <strong>{t('home_landing_stat_2_n')}</strong>
                                <span>{t('home_landing_stat_2_l')}</span>
                            </Stat>
                            <Stat>
                                <strong>{t('home_landing_stat_3_n')}</strong>
                                <span>{t('home_landing_stat_3_l')}</span>
                            </Stat>
                        </StatRow>
                    </div>
                    <HeroVisual>
                        <HeroDevice>
                            <HeroDeviceBezel>
                                <HeroDeviceScreen>
                                    <img
                                        src={heroDashboardScreen}
                                        alt="Dashboard GBinary no notebook"
                                        loading="lazy"
                                        width={1024}
                                        height={644}
                                    />
                                </HeroDeviceScreen>
                            </HeroDeviceBezel>
                            <HeroDeviceBase aria-hidden />
                        </HeroDevice>
                    </HeroVisual>
                </HeroSection>

                <VideoSection id="video">
                    <VideoInner>
                        <SectionKicker>{t('home_landing_video_kicker')}</SectionKicker>
                        <SectionTitle>{t('home_section_use_title')}</SectionTitle>
                        <SectionLead>{t('home_section_use_subtitle')}</SectionLead>
                        <VideoFrame>
                            <iframe
                                title="GBinary — tutorial"
                                src="https://www.youtube.com/embed/JbRVo26uUsI"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                allowFullScreen
                            />
                        </VideoFrame>
                    </VideoInner>
                </VideoSection>

                <Section id="recursos">
                    <SectionHeader>
                        <SectionKicker>{t('home_landing_features_kicker')}</SectionKicker>
                        <SectionTitle>{t('home_section_features_title')}</SectionTitle>
                        <SectionLead>{t('home_section_features_subtitle_v2')}</SectionLead>
                    </SectionHeader>
                    <FeatureGrid>
                        {featureItems.map((item, i) => (
                            <FeatureCard key={i}>
                                <FeatureIcon>{item.icon}</FeatureIcon>
                                <FeatureText>{item.text}</FeatureText>
                            </FeatureCard>
                        ))}
                    </FeatureGrid>
                </Section>

                <Section id="depoimentos">
                    <SectionHeader>
                        <SectionKicker>{t('home_landing_testimonials_kicker')}</SectionKicker>
                        <SectionTitle>{t('home_feedback_title')}</SectionTitle>
                    </SectionHeader>
                    <TestimonialsGrid>
                        {testimonials.map((item) => (
                            <QuoteCard key={item.author}>
                                <QuoteText>{item.quote}</QuoteText>
                                <QuoteAuthor>{item.author}</QuoteAuthor>
                                <Stars>
                                    <AiFillStar />
                                    <AiFillStar />
                                    <AiFillStar />
                                    <AiFillStar />
                                    <AiFillStar />
                                </Stars>
                            </QuoteCard>
                        ))}
                    </TestimonialsGrid>
                </Section>

                <AboutSection id="sobre">
                    <SectionHeader>
                        <SectionKicker>{t('home_landing_about_kicker')}</SectionKicker>
                        <SectionTitle>{t('home_landing_about_title')}</SectionTitle>
                    </SectionHeader>
                    <AboutInner>
                        <AboutProse>
                            <p>{t('home_landing_about_p1')}</p>
                            <p>{t('home_landing_about_p2')}</p>
                            <p>{t('home_landing_about_p3')}</p>
                            <p>{t('home_landing_about_p4')}</p>
                        </AboutProse>
                    </AboutInner>
                </AboutSection>

                <SiteFooter>
                    <FooterWrap>
                        <FooterAccentLine aria-hidden />
                        <FooterTop>
                            <FooterSupportCol>
                                <FooterTitle>{t('support')}</FooterTitle>
                                <FooterMuted>
                                    <div>{t('email')}: app.gbinary@gmail.com</div>
                                    <div>
                                        {t('telephone')}:{' '}
                                        <a
                                            href="#whatsapp"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                handleWhatsAppClick();
                                            }}
                                        >
                                            <BsWhatsapp color="#25D366" style={{ verticalAlign: 'middle' }} />{' '}
                                            (38) 99936-1310
                                        </a>
                                    </div>
                                </FooterMuted>
                            </FooterSupportCol>
                            <FooterLegalCol>
                                <FooterMuted>
                                    <strong style={{ color: 'rgba(255,255,255,0.82)' }}>CNPJ</strong> 62.459.014/0001-25
                                    <br />
                                    Copyright © {year} · {t('rights_reserved')}
                                    <br />
                                    <Link to="/policy-privacy">{t('privacy_policy')}</Link>
                                </FooterMuted>
                            </FooterLegalCol>
                        </FooterTop>
                    </FooterWrap>
                </SiteFooter>
            </ContentZ>
        </LandingRoot>
    );
}
